// extracted by mini-css-extract-plugin
export default {"head__container":"styles_head__container__hRrVI","head__text-title":"styles_head__text-title__l80qZ","head__text--button-cancel":"styles_head__text--button-cancel__prfjy"};